/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2020-04-20 14:03:38
 * @modify date 2020-04-20 14:03:38
 * @desc [description]
 */
import axios from 'axios';

/**
 * getCountryCertificateAuth get api
 * to the certificates list */
export async function getCountryCertificateAuth() {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/country_certificate_auth`)
    .then((response) => {
      if (response.status === 200) result = response.data.data;
    }).catch((err) => {
      console.log('country_certificate_auth java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getArchivingReasons get api
 * to get the exisiting reasons */
export async function getArchivingReasons() {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/archiving_reasons`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get archiving_reasons java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationDetails get api
 * to get Registration Details */
export async function getRegistrationDetails() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/registration`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('getRegistrationDetails java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * Get registration details with pagination POST api
 * to get the registration records list/data */
export async function getRegistrationDetailsByPagination(data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/registration_details`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('Get registration details by pagination JAVA api error', err);
    });
  return result;
}

/**
 * get_account_records_details get api
 * to get the account records upload details */
export async function getRecordUploadDetails() {
  let result = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/account_record_details`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get account_records_details python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationTypeList get api
 * to get registration type list */
export async function getRegistrationTypeList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/registration_type`)
    .then((response) => {
      if (response.status === 200) result = response.data.data;
    }).catch((err) => {
      console.log('get registration_type java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCertificateList get api
 * to get the certificate List */
export async function getCertificateList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/certificate`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get certificate python api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getMedCompContacts get api
 * to get Med Comp Contacts */
export async function getMedCompContacts() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/med_comp_contacts`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get med_comp_contacts python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductList get api
 * to get the prodcuts list */
export async function getProductList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/product_list`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get product_list java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getLocalDistributor get api
 * to get Local Distributor list */
export async function getLocalDistributor() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/local_distributor`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get local_distributor java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getLocalRepresentative get api
 * to get the local Representation */
export async function getLocalRepresentative() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/local_representative`)
    .then((response) => {
      if (response.status === 200) result = response.data.data;
    }).catch((err) => {
      console.log('get local_representative java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductPartNumber get api
 * to get the product barcodes */
export async function getProductPartNumber() {
  let result = {};
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/barcode`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get barcode api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductFamily get api
 * to get the Product Family */
export async function getProductFamily() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/product_family`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get product_family java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getCertificateIssuerList get api
 * to get Certificate Issuer List */
export async function getCertificateIssuerList() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/certificate_issuer`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get certificate_issuer python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getProductClass get api
 * to get the ProductClass based on countryid */
export async function getProductClass(id) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/product_class/${id}`)
    .then((response) => {
      console.log('response', response);
      if (response.data.status_code === 200) result = response.data.data;
    }).catch((err) => {
      console.log('get product_class java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getRelatedCertificates get api
 * to get the realted certificates based on registration id */
export async function getRelatedCertificates(regId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/registration_related_certificates/${regId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get registration_related_certificates java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationHistory get api
 * to get the registration history */
export async function getRegistrationHistory(regId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/registration_history/${regId}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get registration_history java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getMaintenanceCycledays get api
 * to get the maintenance cycle days based on product id */
export async function getMaintenanceCyclePerOrdinance(productId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/maintenance_cycle_per_ordinance?product_id=${productId}`)
    .then((response) => {
      console.log('response', response);
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get maintenance_cycle_per_ordinance java api error', err); // eslint-disable-line no-console
    });
  return result;
}
/**
 * getNextMaintenanceDate get api
 * to get the maintenance date based on product id */
export async function getNextMaintenanceDate(productId) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/calculate_next_maintenance_date_by_product/${productId}`)
    .then((response) => {
      console.log('response', response);
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get calculate_next_maintenance_date_by_product java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * saveRegistrationDetails post api
 * to save single Registration Details */
export async function saveRegistrationDetails(data, newToMarket, fileArrayObject) {
  let result = {};
  const formData = new FormData();
  formData.append('registrationModel', JSON.stringify(data));
  formData.append('isNewRecord', newToMarket);
  Object.keys(fileArrayObject).forEach((category) => {
    if (Object.prototype.hasOwnProperty.call(fileArrayObject, category)) {
      const files = fileArrayObject[category];
      // Check if there are files in the current category
      if (files && files.length > 0) {
        // Iterate over the files in the current category and append them to FormData
        files.forEach((file) => {
          if (category === 'Test Reports') formData.append('test_report_attachments', file.file);
          if (category === 'Product Certificates') formData.append('product_certificate_attachments', file.file);
          if (category === 'Barcodes') formData.append('barcode_attachments', file.file);
          if (category === 'Maintenance Documents') formData.append('maintenance_document_attachments', file.file);
        });
      }
    }
  });
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/registration`, formData, {
      headers: {
        ContentType: 'multipart/form-data'
      }
    })
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('save Registration java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * editRegistration post api
 * to update the registration */
export async function editRegistration(data, reviewCertificate, fileArrayObject) {
  let result = {};
  const formData = new FormData();
  console.log(JSON.stringify(data));
  formData.append('registrationEditModel', JSON.stringify(data));
  Object.keys(fileArrayObject).forEach((category) => {
    if (Object.prototype.hasOwnProperty.call(fileArrayObject, category)) {
      const files = fileArrayObject[category];
      // Check if there are files in the current category
      if (files && files.length > 0) {
        // Iterate over the files in the current category and append them to FormData
        files.forEach((file) => {
          if (category === 'Test Reports' && file.file) formData.append('test_report_attachments', file.file);
          if (category === 'Product Certificates' && file.file) formData.append('product_certificate_attachments', file.file);
          if (category === 'Barcodes' && file.file) formData.append('barcode_attachments', file.file);
          if (category === 'Maintenance Documents' && file.file) formData.append('maintenance_document_attachments', file.file);
        });
      }
    }
  });
  // formData.append('attachments', []);
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/registration_edit_fields?review=${reviewCertificate}`, formData, {
      headers: {
        ContentType: 'multipart/form-data'
      }
    })
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('put call /registration java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function editBulkRegistration(id, data, fileArrayObject) {
  let result = {};
  const formData = new FormData();
  console.log(JSON.stringify(data));
  formData.append('bulkUploadDate', JSON.stringify(data));
  Object.keys(fileArrayObject).forEach((category) => {
    if (Object.prototype.hasOwnProperty.call(fileArrayObject, category)) {
      const files = fileArrayObject[category];
      // Check if there are files in the current category
      if (files && files.length > 0) {
        // Iterate over the files in the current category and append them to FormData
        files.forEach((file) => {
          if (category === 'Test Reports' && file.file) formData.append('test_report_attachments', file.file);
          if (category === 'Product Certificates' && file.file) formData.append('product_certificate_attachments', file.file);
          if (category === 'Barcodes' && file.file) formData.append('barcode_attachments', file.file);
          if (category === 'Maintenance Documents' && file.file) formData.append('maintenance_document_attachments', file.file);
        });
      }
    }
  });
  await axios
    .put(`${process.env.VUE_APP_JAVA_API_URL}/bulk_upload/${id}`, formData)
    .then((response) => {
      console.log(response);
      if (response.status === 200) result = response;
    }).catch((err) => {
      console.log('put call /registration java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * checkDuplicateRegistration post api
 * to check Duplicate Registration */
export async function checkDuplicateRegistration(data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/check_duplicate_registration`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('check_duplicate_registrations python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * deleteMultiRegistrationDetails delete api
 * to delete Multiple RegistrationDetails */
export async function deleteMultiRegistrationDetails(data) {
  let result = '';
  await axios
    .delete(`${process.env.VUE_APP_JAVA_API_URL}/multiRegistrationController`, { data })
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('delete multi_registration java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * archiveMultiRegistrationDetails post api
 * to archive Multiple RegistrationDetails */
export async function archiveMultiRegistrationDetails(option, data) {
  let result = '';
  await axios
    .post(`${process.env.VUE_APP_JAVA_API_URL}/archive_multi_registration/${option}`, data)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('archive_multi_registration java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationDetail get api
 * to get the registration details by passing id */
export async function getRegistrationDetailsById(id) {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/product_registration_by_id/${id}`)
    .then((response) => {
      if (response.status === 200 && response.data.status === 'invalid') {
        result = { error: true };
      } else if (response.status === 200 && response.data) {
        result = response.data;
      }
    })
    .catch((err) => {
      console.log('get registration_detail python api error', err); // eslint-disable-line no-console
    });
  return result;
}

/**
 * getRegistrationDetail get java api
 * to get the registration details by passing id */
export async function getDetailsById(id) {
  let result = '';
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/product_registration_by_id/${id}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    })
    .catch((err) => {
      console.log('get product_registration_by_id java api error', err); // eslint-disable-line no-console
    });
  return result;
}

/* getManageComplianceData get api */
export async function getManageComplianceData() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/managecompliance`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('getManageComplianceData java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function updateStatus(id1, id2) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/renewCertificate?accountId=${id1}&id=${id2}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('getManageComplianceData java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function getDownloadLinkEmail(id) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/downloadLinkSendEmail?id=${id}`)
    .then((response) => {
      if (response.status_code === 200) result = response;
    }).catch((err) => {
      console.log('send email java api error', err); // eslint-disable-line no-console
    });
  return result;
}

export async function downloadComplianceDetails(id) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/downloadManageCompliancePDF?id=${id}`)
    .then((response) => {
      if (response.status_code === 200) result = response;
    }).catch((err) => {
      console.log('send email java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function downloadRegistrationRecords() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/downloadRecords`)
    .then((response) => {
      if (response.status === 200) { result = response.data; }
    }).catch((err) => {
      console.log('send email java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getSubscriptions(showAll) {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/purchase?showAll=${showAll}`)
    .then((response) => {
      if (response.status === 200) result = response.data;
    }).catch((err) => {
      console.log('get subscriptions java api error', err); // eslint-disable-line no-console
    });
  return result;
}
export async function getProductsAvailable() {
  let result = [];
  await axios
    .get(`${process.env.VUE_APP_JAVA_API_URL}/products_available`)
    .then((response) => {
      if (response.status === 200) result = response;
    }).catch((err) => {
      console.log('get products available java api error', err); // eslint-disable-line no-console
    });
  return result;
}
